import localforage from 'localforage'
import * as itemTypes from '../itemModule/mutation-types'
import * as menuTypes from '@/common/store/menuModule/mutation-types'

export default async store => {
  if (await localforage.getItem('version') !== process.env.VUE_APP_VERSION) {
    // await localforage.clear()
    await localforage.setItem('version', process.env.VUE_APP_VERSION)
  }

  /** buckets 的格式:
   *  {
   *    bucket1: {...},
   *    bucket2: {...}
   *  }
  **/
  async function withBucketsId (f) {
    const latestVersion = store.state.menuVariation &&
      store.state.menuModule.latestVersions[store.state.menuVariation]
      ? store.state.menuModule.latestVersions[store.state.menuVariation]
      : null
    if (store.getters.storeId && latestVersion) {
      // 要先檢查 localforage 的 variation 跟 version
      // TODO: 如果發現 localforage 裡面有比較老舊的 version，就要刪掉
      const id = `stores/${store.getters.storeId}/buckets/${store.state.menuVariation}/${latestVersion}`
      f(id, JSON.parse(await localforage.getItem(id) || '{}'))
    }
  }

  store.subscribe(async mutation => {
    switch (mutation.type) {
      case 'itemModule/' + itemTypes.SET_ITEM:
        withBucketsId(async (id, buckets) => {
          const itemBucket = {}
          itemBucket[mutation.payload.itemObj.itemBucket] = store.state.itemModule[mutation.payload.itemObj.itemBucket]
          localforage.setItem(id, JSON.stringify(Object.assign(buckets, itemBucket)))
        })
        break
      case 'itemModule/' + itemTypes.SET_QUESTION:
      case 'itemModule/' + itemTypes.SET_SPECIAL_REQUESTS:
      case 'itemModule/' + itemTypes.REMOVE_ITEM:
      case 'itemModule/' + itemTypes.RESET_BUCKET:
        // 要把資料存到 localforage 裡面
        withBucketsId(async (id, buckets) => {
          const itemBucket = {}
          itemBucket[mutation.payload.itemBucket] = store.state.itemModule[mutation.payload.itemBucket]
          localforage.setItem(id, JSON.stringify(Object.assign(buckets, itemBucket)))
        })
        break
      case 'menuModule/' + menuTypes.PUSH_MENU:
        localforage.setItem(`stores/${store.getters.storeId}/menuVariation`, store.state.menuVariation)
        withBucketsId((id, buckets) =>
          Object.keys(buckets).forEach(bid => {
            if (!store.getters.publicId && bid === 'cart') return
            store.commit('itemModule/' + itemTypes.SET_BUCKET_ITEMS, { bucket: bid, items: buckets[bid] })
          }))
        break
      default:
    }
  })
}
